<div class="mt-1 flex flex-wrap gap-x-4 gap-y-1">
  @for (group of groups; track group?.groupId) {
    <div class="groups flex items-center gap-1">
      <span class="material-symbols-outlined mat-icon small"> group </span>
      <span class="leading-none">{{ group.group }}</span>
    </div>
  }
</div>
